import React from 'react'
import {HotelCard} from 'components/HotelCard'
import {HotelCardProvider} from 'components/HotelCardContext'
import {Hotel} from 'modules/sapiSearch/slice'

interface Props {
  anchorHotelId: Hotel['objectID']
}
const SearchResultsAnchorHotel: React.FC<Props> = ({anchorHotelId}) => {
  return (
    <HotelCardProvider isAnchor hotelId={anchorHotelId}>
      <HotelCard isPriorityCard />
    </HotelCardProvider>
  )
}
export const AnchorHotel = React.memo(SearchResultsAnchorHotel)
